import { gql } from 'apollo-angular';

export const PUBLISH_TIME_SERIES_METRIC_EVENT_MUTATION = gql`
  mutation publishTimeSeriesMetricEvent($metricName: String) {
    publishTimeSeriesMetricEvent(metricName: $metricName)
  }
`;
